import React from "react";

export default function MyDocumentsSkeleton({
  isDarkMode = false,
}: {
  isDarkMode?: boolean;
}) {
  const card = isDarkMode
    ? "bg-gray-800 border-gray-700"
    : "bg-white border-gray-200";
  const shimmer = isDarkMode ? "bg-gray-700" : "bg-gray-200";

  return (
    <div className={`rounded-lg border ${card}`}>
      <div
        className={`p-4 border-b ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
      >
        <div className="flex items-center gap-3">
          <div className={`h-4 w-8 rounded ${shimmer} `} />
          <div className={`h-4 w-32 rounded ${shimmer} `} />
          <div className={`h-4 w-16 rounded ml-auto ${shimmer} `} />
        </div>
      </div>
      <div className="divide-y divide-gray-200 dark:divide-gray-700">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="p-4 grid grid-cols-12 gap-4 items-center">
            <div className={`col-span-4 h-4 rounded ${shimmer} `} />
            <div className={`col-span-3 h-4 rounded ${shimmer} `} />
            <div className={`col-span-2 h-4 rounded ${shimmer} `} />
            <div className={`col-span-3 h-8 rounded ${shimmer} `} />
          </div>
        ))}
      </div>
    </div>
  );
}
